export default __webpack_public_path__ + "static/media/02.03caee69.png";